import axios from 'axios'
// import store from '../store'
import storageUtils from '@/utils/storageUtils'
// const USER_KEY = 'user_key'
import { ERR_USER, ERR_TOKEN_CODE, APP_NOT_EXIST } from '@/utils/constants'
import { uuid } from '@/utils/shared'
function createHeaders() {
  const osVersion = storageUtils.getOsVersion()
  const platformType = storageUtils.getPlatformType()
  const deviceId = storageUtils.getDeviceId()
  // 本地联调临时token
  // const userId = '4656088042'
  const userId = storageUtils.getUserId()
  const lang = storageUtils.getLang()
  // 本地联调临时token
  // const token =
  //   'b78db368c56242f66f6f7dd8b02cefaf4276858e186462e2413594fa3dcf683f'
  const token = storageUtils.getToken()
  // 时区(秒)
  const timezone = new Date().getTimezoneOffset() * 60
  const jwToken = storageUtils.getJwToken()
  const headers = {
    __CXY_OS_VER_: osVersion,
    __CXY_OS_LANG_: lang,
    __CXY_BRAND_: 'creality',
    __CXY_APP_CH_: 'creality-admin',
    __CXY_PLATFORM_: platformType,
    __CXY_TIMEZONE_: -timezone,
    __CXY_DUID_: deviceId,
    __CXY_APP_ID_: process.env.VUE_APP_ID,
    __CXY_APP_VER_: process.env.VUE_APP_VER,
    __CXY_REQUESTID_: uuid()
  }
  if (token) {
    headers.__CXY_TOKEN_ = token
    headers.__CXY_UID_ = userId
  }
  if (jwToken) {
    headers.__CXY_JWTOKEN_ = jwToken
  }
  return headers
}

// 添加请求拦截器
axios.interceptors.request.use(
  function(config) {
    // 在发送请求之前做些什么
    const extraHeaders = createHeaders()
    if (config.method === 'get') {
      config.data = true
    }
    Object.keys(extraHeaders).forEach(key => {
      config.headers[key] = extraHeaders[key]
    })
    if (config.data.token) config.data.token = undefined
    if (config.method === 'post') {
      const newData = config.data
      for (const key in newData) {
        if (typeof newData[key] === 'string') {
          newData[key] = newData[key].trim()
        }
      }
      newData.begin = newData.begin || undefined
      newData.end = newData.end || undefined
      newData.regEndTime = newData.regEndTime || undefined
      newData.regStartTime = newData.regStartTime || undefined
      // 机器人评论时 换token
      if (newData.item && newData.item.robotToken) {
        config.headers['__CXY_TOKEN_'] = newData.item.robotToken
        config.headers['__CXY_UID_'] = newData.item.robotUserId
      }
    }
    return config
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

export default function ajax(
  url,
  data = {},
  type = 'GET',
  responseType = undefined
) {
  return new Promise(function(resolve, reject) {
    let promise

    if (type === 'GET') {
      let dataStr = ''
      Object.keys(data).forEach(key => {
        dataStr += key + '=' + data[key] + '&'
      })
      if (dataStr !== '') {
        dataStr = dataStr.substring(0, dataStr.lastIndexOf('&'))
        url = url + '?' + dataStr
      }
      promise = axios.get(url)
    } else {
      promise = axios.post(url, data, responseType)
    }
    promise
      .then(
        response => {
          if (response.data) {
            const data = response.data
            const code = data.code
            const err_token = parseInt(ERR_TOKEN_CODE)
            const err_user = parseInt(ERR_USER)
            const err_app = parseInt(APP_NOT_EXIST)
            if (code === err_token || code === err_app) {
              window.dispatchEvent(new Event('tokenError'))
              return
            } else if (code === err_user) {
              // 服务器报身份错误 自定义权限错误
              const url = response.config.url
              data.msg = `该页面的某些操作，当前账号无权限: ${url}，请联系相关运营同事处理。`
              resolve(data)
            } else {
              resolve(responseType ? response : data)
            }
          }
        },
        error => {
          resolve({
            code: 'error',
            msg: error.message
          })
        }
      )
      .catch(function(error) {
        reject(error)
      })
  })
}
